// HowWeWork section — the "How we work" principles list. Mounted by
// Landing.tsx. Copy is the owner's own words (7 September 2026).
//
// Rows are whitespace-separated (no card borders): each row is a vertical
// stack of a row glyph, a heading, and a paragraph. At >= 900px the rows
// container becomes a 3-column grid (one row per column); below that they
// stack, in the same DOM order, one below the other.
//
// The row glyphs count. It is the same dashed cube each time with a
// different face lit, top, then front-right, then front-left, clockwise as
// the viewer sees it (CubeGlyph's FACE_ORDER). Three points, three faces:
// the cube itself is the 1 / 2 / 3, and the closing cube further down
// cycles through the same three faces in the same order. The H2 carries no
// marker of its own; every mark on the page is a cube, and this section's
// three are its rows.
import { CubeGlyph, FACE_ORDER } from '../marks/CubeGlyph';
import './HowWeWork.css';

export function HowWeWork() {
  return (
    <section className="section how-we-work" data-mood="how">
      <div className="wrap">
        <div className="sechead">
          <h2>How we work.</h2>
        </div>
        <div className="how-we-work__rows">
          <div className="content-row">
            <CubeGlyph tone="dash" size={28} face={FACE_ORDER[0]} />
            <h3>We measure before we build.</h3>
            <p>
              Before we write code, we find out what is happening on the ground: how
              often, to whom, and what it costs you. A vague complaint becomes
              structure, and that structure sets the plan. When something cannot be
              measured, we say so and call it a guess.
            </p>
          </div>
          <div className="content-row">
            <CubeGlyph tone="dash" size={28} face={FACE_ORDER[1]} />
            <h3>We write things down.</h3>
            <p>
              Proposals with clear scope. Design documents before code. A written record
              of what went wrong and what we did about it. You get to read all of it.
            </p>
          </div>
          <div className="content-row">
            <CubeGlyph tone="dash" size={28} face={FACE_ORDER[2]} />
            <h3>You can own what we build.</h3>
            <p>
              Full handover is an option at an added cost: source code and everything
              needed to run it, so another firm could pick your system up. Without it,
              we keep running it for you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
